import { Form, Input, InputNumber } from "antd";
import { requiredField } from "../common/common";
import SimpleFormPage from "../common/SimpleFormPage";
import { useLoaderData } from "react-router";

export default function () {
  const data = useLoaderData();
  const loadFn = (form) => form.setFieldsValue(data);

  return (
    <SimpleFormPage
      title="Modifica categoria allestimento"
      loadFn={loadFn}
      layout="vertical"
      autoComplete="off"
    >
      <Form.Item label="Descrizione" rules={[requiredField]} name="description">
        <Input />
      </Form.Item>
      <Form.Item label="Revisione ogni" name="inspectionMonths">
        <InputNumber controls={false} precision={0} suffix="mesi" />
      </Form.Item>
    </SimpleFormPage>
  );
}
